import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  Backdrop
} from "@mui/material";
import { useState } from "react";
import SendIcon from '@mui/icons-material/Send';
import WarningIcon from '@mui/icons-material/Warning';
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const ContextoValidation = ({
  open,
  onClose,
  nomeContexto = '',
  contexto = '',
  onConfirm,
  produto,
  produtoId // Nova prop
}) => {
  const [justificativa, setJustificativa] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [feedbackState, setFeedbackState] = useState(''); // 'success', 'error', ou ''
  const [errorMessage, setErrorMessage] = useState('');
  const [errorCode, setErrorCode] = useState(null);

  const chaveContexto = produto === "AC" ? nomeContexto.toLowerCase() : nomeContexto;

  let resultado;

  switch (produto) {
    case 'AV':
      resultado = 1;
      break;

    case 'sdr':
      resultado = 2;
      break;

    case 'AC':
      resultado = 3;
      break;

    case 'POSV':
    case 'posv':
      resultado = 5;
      break;

    default:
      resultado = -1;
      break;
  }

  // Função para extrair nome do usuário do token JWT no localStorage
  const getNomeUsuario = () => {
    try {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        // Decodifica o JWT (payload está na segunda parte)
        const decodedToken = jwtDecode(token);
        const nomeUsuario = decodedToken.nome;

        return nomeUsuario || 'Usuário não identificado';
      }
      return 'Usuário não identificado';
    } catch (error) {
      console.error('Erro ao decodificar token JWT:', error);
      return 'Usuário não identificado';
    }
  };

  const handleEnviarContexto = async () => {
    setIsLoading(true); // Inicia o loading

    try {
      const token = localStorage.getItem('jwtToken');
      if (!token) {
        console.error("Token não encontrado no localStorage.");
        setIsLoading(false);
        return;
      }

      // Decodificar o token para extrair dados do usuário
      const decodedToken = jwtDecode(token);
      const nomeUsuario = decodedToken.nome || 'Usuário não identificado';
      const idClienteAipim = decodedToken.id_cliente;
      const idUsuario = decodedToken.id_usuario;
      const idProduto = resultado;

      const agora = new Date();
      const dataHora = agora.toLocaleString('pt-BR');

      console.log('=== INÍCIO DEBUG ===');
      console.log('Produto:', produto);
      console.log('Nome Contexto:', nomeContexto);
      console.log('Empreendimento ID:', produtoId);
      console.log('Chave Contexto:', chaveContexto);
      console.log('ID Cliente Aipim:', idClienteAipim);

      // ========== PRIMEIRA ETAPA: ENVIAR JUSTIFICATIVA ==========
      const baseURL = process.env.REACT_APP_API_BASE_URL;

      let dadosAtuais;

      console.log('=== CONFIGURAÇÃO DA REQUISIÇÃO GET ===');
      if (produto === 'sdr' && nomeContexto === 'contextoInstitucional') {
        console.log('Usando URL: /produto/sdr/contexto-institucionall');
        console.log('Params:', { idClienteAipim: idClienteAipim });
      } else if (produto === 'sdr' && nomeContexto === 'contextoProduto') {
        console.log('Usando URL: /produto/sdr/contexto-produto');
        console.log('Params:', { idClienteAipim: idClienteAipim, id: produtoId });
      } else {
        console.log('Usando URL padrão: /produto/' + produto + '/contextos');
        console.log('Params:', { idClienteAipim: idClienteAipim });
      }

      if (produto === 'sdr' && nomeContexto === 'contextoInstitucional') {
        // URL específica para SDR contextoInstitucional
        dadosAtuais = await axios.get(`${baseURL}/produto/sdr/contexto-institucional`, {
          params: { idClienteAipim: idClienteAipim },
          headers: { Authorization: `Bearer ${token}` }
        });
      } else if (produto === 'sdr' && nomeContexto === 'contextoProduto') {
        // Nova URL para SDR contextoProduto
        dadosAtuais = await axios.get(`${baseURL}/produto/sdr/contexto-produto`, {
          params: { idClienteAipim: idClienteAipim, id: produtoId },
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        // URL padrão para outros casos
        dadosAtuais = await axios.get(`${baseURL}/produto/${produto}/contextos`, {
          params: { idClienteAipim: idClienteAipim },
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      console.log('=== RESPOSTA DA REQUISIÇÃO GET ===');
      console.log('Status da resposta:', dadosAtuais.status);
      console.log('Dados retornados:', dadosAtuais.data);
      console.log('Primeiro objeto dos dados:', dadosAtuais.data[0]);

      const dadosOriginais = dadosAtuais.data[0] === undefined ? dadosAtuais.data : dadosAtuais.data[0];

      // Capturar o valor anterior do contexto específico
      let valorAnterior

      if (produto === 'sdr' && nomeContexto === 'contextoProduto') {
        // Para SDR contextoProduto, o valor anterior vem direto da propriedade 'contexto'
        valorAnterior = dadosOriginais === null || dadosOriginais === undefined ? " " : dadosOriginais.contexto;
      } else {
        // Para outros casos, usa a chave normal
        valorAnterior = dadosOriginais[chaveContexto] === null || dadosOriginais[chaveContexto] === undefined ? " " : dadosOriginais[chaveContexto];
      }

      console.log('=== CAPTURA DO VALOR ANTERIOR ===');
      console.log('Dados Originais:', dadosOriginais);
      console.log('Chave que será acessada:', chaveContexto);
      console.log('Valor anterior capturado:', valorAnterior);

      console.log('=== PAYLOAD DA JUSTIFICATIVA ===');

      const payload = {
        idClienteAipim: idClienteAipim,
        idUsuario: idUsuario,
        idProduto: idProduto,
        campo: nomeContexto === "contextoInstitucional" ? "Contexto_institucional" :
          nomeContexto === "contextoProduto" ? "Contexto_produto" :
            nomeContexto,
        valorNovo: contexto,
        valorAnterior: valorAnterior == null ? " " : valorAnterior,
        justificativa: justificativa,
      };

      console.log('Payload completo:', payload);

      // Envia a justificativa primeiro
      const justificativaResponse = await axios.post(
        `${baseURL}/produto/Justificativa`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );

      if (justificativaResponse) {
        console.log("Ok")
      }

      // ========== SEGUNDA ETAPA: ATUALIZAR O CONTEXTO ==========

      const dadosContexto = dadosAtuais.data[0] == null ? dadosAtuais.data : dadosAtuais.data[0];

      // Monta o payload com todos os campos necessários
      const contextoPayload = {
        id: dadosContexto.id,
        idClienteAipim: idClienteAipim,
        ...dadosContexto, // Inclui todos os contextos existentes
        [chaveContexto]: contexto || null // Sobrescreve apenas o contexto alterado
      };

      // Remove as propriedades que não são contextos para não duplicar
      delete contextoPayload.id; // Remove para não duplicar no spread
      delete contextoPayload.idClienteAipim; // Remove para não duplicar no spread

      console.log('=== PAYLOAD DA ATUALIZAÇÃO ===');
      console.log('Dados do Contexto:', dadosContexto);

      // Reconstrói o payload final
      const payloadFinal = produto === 'sdr' && nomeContexto === 'contextoProduto'
        ? {
          id: produtoId, // Usar o ID do empreendimento em vez do ID dos dados
          idClienteAipim: idClienteAipim,
          "contexto": contexto || null
        }
        : {
          id: dadosContexto.id,
          idClienteAipim: idClienteAipim,
          [chaveContexto]: contexto || null
        };

      console.log('Payload Final:', payloadFinal);

      let updateResponse;

      if (produto === 'sdr' && nomeContexto === 'contextoInstitucional') {
        // URL e payload específicos para SDR contextoInstitucional
        updateResponse = await axios.put(
          `${baseURL}/produto/sdr/contexto-institucional`,
          payloadFinal,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            }
          }
        );
      } else if (produto === 'sdr' && nomeContexto === 'contextoProduto') {
        // Nova URL para SDR contextoProduto
        updateResponse = await axios.put(
          `${baseURL}/produto/sdr/contexto-produto`,
          payloadFinal,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            }
          }
        );
      } else {
        // URL padrão para outros casos
        updateResponse = await axios.put(
          `${baseURL}/produto/${produto}/contextos`,
          payloadFinal,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            }
          }
        );
      }

      if (updateResponse) {
        console.log("Ok")
      }

      setFeedbackState('success');
      setIsLoading(false);

      // ========== TERCEIRA ETAPA: SÓ CONFIRMA SE TUDO DEU CERTO ==========
      // Chama a função de confirmação do componente pai apenas se chegou até aqui sem erro
      if (onConfirm) {
        onConfirm({
          nomeUsuario,
          nomeContexto,
          contexto,
          justificativa,
          dataHora
        });
      }

      // Reset e fecha o modal apenas em caso de sucesso
      setJustificativa('');
      setIsLoading(false);

    } catch (error) {
      console.error("Erro ao enviar justificativa:", error);
      setIsLoading(false);
      setFeedbackState('error');
      setErrorCode(error.response?.status || 'unknown');

      let mensagemErro = "Erro desconhecido ao enviar justificativa.";

      if (error.response?.status === 401) {
        mensagemErro = "Sua sessão expirou. Faça login novamente.";
      } else if (error.response?.status === 403) {
        mensagemErro = "Você não tem permissão para esta operação.";
      } else if (error.response?.status === 404) {
        mensagemErro = "Recurso não encontrado. Verifique se o produto existe.";
      } else if (error.response?.status === 500) {
        mensagemErro = "Erro interno do servidor. Tente novamente em alguns minutos.";
      } else if (error.response?.data?.message) {
        mensagemErro = error.response.data.message;
      } else {
        mensagemErro = "Erro de conexão. Verifique sua internet e tente novamente.";
      }

      setErrorMessage(mensagemErro);
    }
  };

  const handleClose = () => {
    if (isLoading || feedbackState !== '') return; // Impede fechar durante loading ou feedback
    setJustificativa('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
          position: 'relative',
          bgcolor: 'background.paper',
          color: 'text.primary',
        }
      }}
    >
      {/* Backdrop de Loading */}
      {/* Backdrop de Loading/Success/Error */}
      <Backdrop
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(15, 23, 42, 0.96)'
              : 'rgba(255, 255, 255, 0.95)',
          zIndex: 1,
          borderRadius: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}
        open={isLoading || feedbackState !== ''}
      >
        {isLoading && (
          <>
            <CircularProgress size={50} thickness={4} />
            <Typography variant="body1" sx={{ fontWeight: 600, color: 'primary.main' }}>
              Salvando contexto...
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
              Aguarde enquanto processamos sua solicitação
            </Typography>
          </>
        )}

        {feedbackState === 'success' && (
          <>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                backgroundColor: '#4caf50',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 1
              }}
            >
              <Typography variant="h4" sx={{ color: 'white' }}>✓</Typography>
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#4caf50', textAlign: 'center' }}>
              Contexto atualizado com sucesso!
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 1 }}>
              Suas alterações foram salvas
            </Typography>
            <Button
              variant="contained"
              onClick={() => {
                setFeedbackState('');
                setJustificativa('');
                onClose();
                if (onConfirm) {
                  const agora = new Date();
                  const dataHora = agora.toLocaleString('pt-BR');
                  onConfirm({
                    nomeUsuario: getNomeUsuario(),
                    nomeContexto,
                    contexto,
                    justificativa,
                    dataHora
                  });
                }
              }}
              sx={{
                backgroundColor: '#4caf50',
                '&:hover': { backgroundColor: '#45a049' },
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3
              }}
            >
              Continuar
            </Button>
          </>
        )}

        {feedbackState === 'error' && (
          <>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                backgroundColor: '#f44336',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 1
              }}
            >
              <Typography variant="h4" sx={{ color: 'white' }}>✕</Typography>
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#f44336', textAlign: 'center' }}>
              Erro ao atualizar contexto
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 2, overflowWrap: 'anywhere' }}>
              {errorMessage}
            </Typography>

            {/* Instruções específicas baseadas no erro */}
            {errorCode === 401 && (
              <Typography variant="body2" sx={{ color: '#ff9800', textAlign: 'center', mb: 2, fontWeight: 600 }}>
                Recomendação: Faça logout e login novamente
              </Typography>
            )}
            {errorCode === 403 && (
              <Typography variant="body2" sx={{ color: '#ff9800', textAlign: 'center', mb: 2, fontWeight: 600 }}>
                Recomendação: Entre em contato com o administrador
              </Typography>
            )}
            {errorCode === 404 && (
              <Typography variant="body2" sx={{ color: '#ff9800', textAlign: 'center', mb: 2, fontWeight: 600 }}>
                Recomendação: Verifique se você selecionou o produto correto
              </Typography>
            )}
            {errorCode === 500 && (
              <Typography variant="body2" sx={{ color: '#ff9800', textAlign: 'center', mb: 2, fontWeight: 600 }}>
                Recomendação: Aguarde alguns minutos e tente novamente
              </Typography>
            )}

            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setFeedbackState('');
                  setErrorMessage('');
                  setErrorCode(null);
                }}
                sx={{
                  borderColor: '#f44336',
                  color: '#f44336',
                  '&:hover': { borderColor: '#d32f2f', backgroundColor: 'rgba(244, 67, 54, 0.04)' },
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Tentar Novamente
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setFeedbackState('');
                  setErrorMessage('');
                  setErrorCode(null);
                  setJustificativa('');
                  onClose();
                }}
                sx={{
                  backgroundColor: '#666',
                  '&:hover': { backgroundColor: '#555' },
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Fechar
              </Button>
            </Box>
          </>
        )}
      </Backdrop>

      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon sx={{ color: '#ff9800', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#d32f2f' }}>
            ATENÇÃO!
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pb: 2 }}>
        <Alert
          severity="warning"
          sx={{
            mb: 3,
            '& .MuiAlert-message': {
              width: '100%'
            }
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
            {getNomeUsuario()}
          </Typography>
          <Typography variant="body2">
            A informação incluída/alterada pode produzir mudanças de comportamento do seu Agente.
          </Typography>
        </Alert>

        <Typography
          variant="body1"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: 'text.primary'
          }}
        >
          Justificativa da mudança:
        </Typography>

        <TextField
          multiline
          rows={4}
          fullWidth
          value={justificativa}
          onChange={(e) => setJustificativa(e.target.value)}
          placeholder="Digite aqui a justificativa para esta alteração de contexto..."
          variant="outlined"
          required
          disabled={isLoading}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: isLoading ? 'action.disabledBackground' : 'background.default',
              color: 'text.primary',
              '&:hover': {
                backgroundColor: isLoading ? 'action.disabledBackground' : 'action.hover',
              },
              '&.Mui-focused': {
                backgroundColor: 'background.paper',
              }
            },
            '& .MuiOutlinedInput-input': {
              fontSize: '14px',
              lineHeight: 1.5,
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          disabled={isLoading}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleEnviarContexto}
          variant="contained"
          endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
          disabled={!justificativa.trim() || isLoading}
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0',
            },
            '&:disabled': {
              backgroundColor: '#e0e0e0',
              color: '#9e9e9e',
            },
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1
          }}
        >
          {isLoading ? 'Enviando...' : `Enviar`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContextoValidation;
